import React from 'react';
import Hero from './components/phd-dlit/Hero';
import Main from './components/phd-dlit/Main';

const PhdDlit = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default PhdDlit;